import { retrieveAccessToken, BaseClientConfig } from '@news-mono/web-common'

type InteractionType = 'read' | 'saved' | 'viewed'

interface SavedDocument {
    id: number
    userId: string
    publicationId: string
    interactionType: InteractionType
    lastUpdated: Date
}

export interface GetSavedDocumentResult {
    status: number
    statusText?: string
    data?: {
        total: number
        documents: SavedDocument[]
    }
}

interface CustomRequestInit {
    method: string
    body?: any
}

export const getSavedPublications = async (
    config: BaseClientConfig,
    userId: string,
) => {
    try {
        if (!userId)
            return {
                total: 0,
            }

        const url = `${config.profileApi}/user-profile/user-interaction/user/${userId}/type/saved`
        const requestConfig = getRequestConfig()

        return fetch(url, requestConfig).then((response) => response.json())
    } catch (e) {
        return { total: 0 }
    }
}

export const saveArticleToUserProfile = async (
    config: BaseClientConfig,
    userId: string,
    publicationId?: string,
) => {
    if (!publicationId)
        return {
            status: 400,
            statusText: 'Couldn’t save article',
            data: undefined,
        }

    if (!userId)
        return {
            status: 400,
            statusText: 'Couldn’t save article',
            data: undefined,
        }

    try {
        const url = `${config.profileApi}/user-profile/user-interaction`
        const customInit = {
            method: 'POST',
            body: JSON.stringify({
                userId,
                publicationId,
                interactionType: 'saved',
            }),
        }

        const requestConfig = getRequestConfig(customInit)
        const myRequest = new Request(url, requestConfig)

        return fetch(myRequest)
            .then((response) => response.json())
            .catch(() => {
                return {
                    status: 500,
                    statusText: 'Couldn’t save article',
                    data: undefined,
                }
            })
    } catch (e) {
        return {
            status: 500,
            statusText: 'Couldn’t save article',
            data: undefined,
        }
    }
}

export const unsaveArticleFromUserProfile = async (
    config: BaseClientConfig,
    id?: string,
) => {
    if (!id)
        return {
            status: 400,
            statusText: 'Couldn’t save article',
            data: undefined,
        }

    try {
        const url = `${config.profileApi}/user-profile/user-interaction/${id}`
        const requestConfig = getRequestConfig({ method: 'DELETE' })

        return fetch(url, requestConfig)
            .then((response) => response.json())
            .catch(() => {
                return {
                    status: 500,
                    statusText: 'Couldn’t save article',
                    data: undefined,
                }
            })
    } catch (e) {
        return {
            status: 500,
            statusText: 'Couldn’t save article',
            data: undefined,
        }
    }
}

export const isPublicationSaved = (
    publicationId: string,
    savedDocuments: SavedDocument[],
) => {
    return savedDocuments.find(
        (pub) =>
            pub.publicationId.toUpperCase() === publicationId.toUpperCase(),
    )
}

const getRequestConfig = (customRequestInit?: CustomRequestInit) => {
    const accessTokenState = retrieveAccessToken()
    return {
        ...customRequestInit,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessTokenState?.accessToken}`,
        },
    }
}
